import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import { useIsMobile } from '../../hooks/useIsMobile'
import { useIsTablet } from '../../hooks/useIsTablet'
import { getDetailsById } from '../../redux/actions/DesignDetailsAction'
import { getFollowList } from '../../redux/actions/FollowingActions'
import { PriceTagClear } from '../../redux/actions/PriceTagActions'
import { GetAllSavedProducts } from '../../redux/actions/SaveProductAction'
import { setHideFloatingButtons } from '../../redux/designerReducers/locationStateReducer'
import Detail from '../DesignerCommon/Detail'
import { LoadingIndicator2 } from '../Loading'
import * as styles from './details.module.css'
import { CaptionModal } from '../CaptionModal'
import { Main } from './Main'
import { Products } from './Products'

const Details = props => {
  const dispatch = useDispatch()
  const { query } = useRouter()
  const id = props.id ? props.id : query?.designId

  useEffect(() => {
    batch(() => {
      dispatch(getDetailsById(id))
      dispatch(PriceTagClear())
      dispatch(GetAllSavedProducts())
      dispatch(getFollowList())
    })
  }, [dispatch, id])

  return (
    <>
      <DetailsContainer {...props} />
    </>
  )
}

const DetailsContainer = props => {
  const { query } = useRouter()
  const id = props.id ? props.id : query.designId
  const {
    data: mainData,
    loading,
    likes: active,
    numLikes
  } = useSelector(state => state.designdetails)
  const { allSavedProducts } = useSelector(state => state.saveProduct) // all saved products with objectids
  const [zoom, setZoom] = useState(1)
  const [show, setShow] = useState(true)
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const dispatch = useDispatch()
  const [showCaptionModal, setShowCaptionModal] = useState(false)

  function showDiv(e) {
    if (!isMobile && !isTablet) return

    if (
      e.target.id === 'currentItem' ||
      e.target.id === 'currentArrow' ||
      e.target.parentNode.id === 'currentArrow'
    ) {
      if (show) {
        dispatch(setHideFloatingButtons(true))

        setShow(false)
        document.getElementById('products').style.height = 'auto'
        document.getElementById('showall').style.display = 'flex'
        document
          .getElementById('currentItemIcon')
          .classList.add('currentItemIcon')
      } else {
        dispatch(setHideFloatingButtons(false))

        setShow(true)
        document.getElementById('products').style.height = '85px'
        document.getElementById('showall').style.display = 'none'
        document
          .getElementById('currentItemIcon')
          .classList.remove('currentItemIcon')
      }
    }
  }

  useEffect(() => {
    function updateSize() {
      if (!isMobile && !isTablet) return

      if (window.innerWidth >= 1034 && window.innerWidth <= 1376) {
        document.getElementById('products').style.height = '800px'
        document.getElementById('showall').style.display = 'block'
        document
          .getElementById('currentItemIcon')
          .classList.add('currentItemIcon')
        setZoom(window.innerWidth / 1366)
      } else if (window.innerWidth >= 1376) {
        document.getElementById('products').style.height = '800px'
        document.getElementById('showall').style.display = 'block'
        document
          .getElementById('currentItemIcon')
          .classList.add('currentItemIcon')
        setZoom(1)
      } else {
        document.getElementById('products').style.height = '85px'
        document.getElementById('showall').style.display = 'none'
        document
          .getElementById('currentItemIcon')
          .classList.remove('currentItemIcon')
        setZoom(1)
      }
    }
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [isMobile, isTablet])

  return (
    <>
      <LoadingIndicator2 loading={loading} />
      {!loading && (
        <>
          <div className={styles.backContainer}>
            <Detail title="" />
          </div>
          <div
            className={`${styles.detailContainer} ${styles.noModal}`}
            style={{ zoom: zoom }}
            onClick={showDiv}
          >
            <Main
              id={id}
              active={active}
              data={mainData}
              numLikes={numLikes}
              showCaptionModal={() => {
                setShowCaptionModal(true)
              }}
            />
            <Products
              id={id}
              data={mainData}
              allSavedProducts={allSavedProducts}
            />
          </div>
        </>
      )}
      {!!mainData?.objectId && showCaptionModal && (
        <CaptionModal
          data={mainData}
          handleClose={() => setShowCaptionModal(false)}
        />
      )}
    </>
  )
}

export default Details
